/**
 * Makeup Styles screen (makeup_styles tool): the shared style-template screen
 * with an intensity picker and a natural-skin-texture switch. See ./styleTool.ts.
 */
import { renderStyleTool } from './styleTool.js';
import { makeupOptions } from './toolOptions.js';

export function renderMakeupStyles(root: HTMLElement, query: URLSearchParams): void {
  renderStyleTool(root, query, {
    tool: 'makeup_styles',
    title: 'Makeup Styles',
    subtitle: 'Try different makeup looks with AI.',
    stylesTitle: 'Choose a makeup style',
    seeAllHref: '#/category/makeup',
    cta: 'Generate Makeup',
    emptyIcon: 'brush',
    emptyText: 'No makeup styles are available yet. Please check back soon.',
    makeOptions: makeupOptions,
  });
}
